'use strict';

wbApp.controller('UsersCtrl', ['$scope', '$http', '$q', '$modal', '$translate', '$filter', 'userSvc', 'userRolesSvc', 
    'referenceSourceSvc', 'gridSortSvc', 'securitySvc', 'messageBoxSvc', '$timeout', 'tenantSettingSvc',
function ($scope, $http, $q, $modal, $translate, $filter, userSvc, userRolesSvc, 
          referenceSourceSvc, gridSortSvc, securitySvc, messageBoxSvc, $timeout, tenantSettingSvc) {

    $scope.customFilter = { unfinishedRegistrations: false };
    $scope.users = [];
    
    $scope.tenantSetting = tenantSettingSvc.settings;
    let hasSecondContact =
        ($scope.tenantSetting.mandatoryEmail2 < 3) ||
        ($scope.tenantSetting.mandatoryPhone2 < 3) ||
        ($scope.tenantSetting.mandatoryUserNationality2 < 3) ||
        ($scope.tenantSetting.mandatoryUserName2 < 3) ||
        ($scope.tenantSetting.mandatoryUserSurname2 < 3) ||
        ($scope.tenantSetting.mandatoryUserMiddleName2 < 3) ||
        ($scope.tenantSetting.mandatoryUserAddress2 < 3) ||
        ($scope.tenantSetting.mandatoryUserIdentityCardNumber2 < 3) ||
        ($scope.tenantSetting.mandatoryUserPersonalIDNumber2 < 3) ||
        ($scope.tenantSetting.mandatoryUserBirthday2 < 3);
    
    
    $scope.$watch('customFilter.unfinishedRegistrations', function (newValue, oldValue) {
        $scope.users = userSvc.getAllAsync(true, !newValue);
    }, true);    
    
    function sendInvitationToUser(usersToInvite, idx, progressCallback)
    {
        if (usersToInvite.length >= (idx + 1)) {
            var user = angular.copy(usersToInvite[idx]);
            user.requestBindToIDM = true;
            userSvc.update(user,
                function () {
                    progressCallback({
                        pctProgress: (((idx + 1) / usersToInvite.length) * 100) % 101,
                        progressMsg: 'OK - ' + user.fullName + ' (' + user.email + ')',
                        status: 0
                    });                
                    $timeout(function () {
                        sendInvitationToUser(usersToInvite, idx + 1, progressCallback);
                    }, 600);
                },
                function (error) {
                    let errorMsg = _.join(_.map(error.errors || [], 'message'), ',');
                    progressCallback({
                        pctProgress: (((idx + 1) / usersToInvite.length) * 100) % 101,
                        progressMsg: 'ERROR - ' + user.fullName + ' (' + user.email + ') : ' + errorMsg,
                        status: 1
                    });
                    $timeout(function () {
                        sendInvitationToUser(usersToInvite, idx + 1, progressCallback);
                    }, 600);
                }, true);
        } else {
            progressCallback({
                pctProgress: 100,
                progressMsg: $translate.instant('TXT_FINISH'),
                status: 2
            });
        }
    }

    function sendInvitationToAll(reSendOnly) {

        function sendInvitationToAllImpl(usersToInvite) {
            if (usersToInvite.length > 0) {
                var callback = messageBoxSvc.showPctProgress(
                    $translate.instant('TXT_SEND_INVITATION_PROGRESS_TITLE'),
                    $translate.instant('TXT_SEND_INVITATION_PROGRESS_DESC'));
                sendInvitationToUser(usersToInvite, 0, callback);
            }
        }
        
        if (reSendOnly) {
            var boundUsersToReInvite = _.filter($scope.users, function (user) {
                return !user.isAnonymized && !user.isDisabled && !user.idmEmailConfirmed && user.boundToIDM && user.allowEmailContact;
            });

            messageBoxSvc.showMessageDlg({
                title: 'TXT_RE_SEND_INVITATION_CONFIRM_TITLE',
                message: $translate.instant('TXT_RE_SEND_INVITATION_CONFIRM_DESC').f(boundUsersToReInvite.length),
                buttons: [{
                    text: 'TXT_BTN_SEND',
                    callback: function () { sendInvitationToAllImpl(boundUsersToReInvite); }
                }, {
                    text: 'TXT_BTN_CANCEL',
                    primary: true
                }]
            });
        } else {
            var notBoundUsersToInvite = _.filter($scope.users, function (user) {
                return !user.isAnonymized && !user.isDisabled && !user.idmEmailConfirmed && !user.boundToIDM && user.allowEmailContact;
            });

            messageBoxSvc.showMessageDlg({
                title: 'TXT_SEND_INVITATION_CONFIRM_TITLE',
                message: $translate.instant('TXT_SEND_INVITATION_CONFIRM_DESC').f(notBoundUsersToInvite.length),
                buttons: [{
                    text: 'TXT_BTN_SEND',
                    callback: function () { sendInvitationToAllImpl(notBoundUsersToInvite); }
                }, {
                    text: 'TXT_BTN_CANCEL',
                    primary: true
                }]
            });
        }
    }

    $scope.gridSettings = {
        name: 'users',
        keyExpr: 'id',
        columns: [
            {
                dataField: 'fullName', caption: $translate.instant('TXT_HUMAN_NAME'), dataType: 'string', sortOrder: 'asc',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName(data, 'name', 'surname', 'middleName') }
            },
            {
                dataField: 'securityRoleID',
                caption: $translate.instant('TXT_LBL_ROLE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('userRole')(rowData.securityRoleID);
                },
                width: '100px'
            },
            { dataField: 'email', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string', width: '180px' },
            {
                dataField: 'phone',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.phone);
                },
                width: '140px'
            },
            { dataField: 'lastActivity', caption: $translate.instant("TXT_LBL_LAST_ACTIVITY"), dataType: 'datetime', format: { datetime: 'short' }, width: '110px' },
            {
                dataField: 'referenceSourceID',
                caption: $translate.instant('TXT_LBL_REFERENCE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('referenceSource')(rowData.referenceSourceID);
                },
                width: '100px'
            },
            { dataField: 'allowEmailContact', caption: $translate.instant('TXT_LBL_ALLOW_EMAIL_CONTACT'), dataType: 'boolean', width: '60px' },
            { dataField: 'idmEmailConfirmed', caption: $translate.instant('TXT_IDENTITY_CONFIRMED'), dataType: 'boolean', width: '60px' },
        ],
        shouldDisableExportMenu: function () {
            return !securitySvc.isInRole('User.Export');
        },
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);
                if (data.isDisabled) {
                    e.rowElement.addClass('text-danger');
                }
            }
        },
        customCommands: [{
            text: $translate.instant('TXT_RE_SEND_INVITATION_CONFIRM_TITLE'),
            isVisible: function () { return securitySvc.isInRole('User.Update'); },
            callback: function (data) { sendInvitationToAll(true); }
        }, {
            text: $translate.instant('TXT_SEND_INVITATION_CONFIRM_TITLE'),
            isVisible: function () { return securitySvc.isInRole('User.Update'); },
            callback: function (data) { sendInvitationToAll(false); }
        }]
    }

    $q.all([userRolesSvc.getAllAsync().$promise, referenceSourceSvc.getAllAsync().$promise])
        .then(function () {
            $scope.users = userSvc.getAllAsync(true, !$scope.customFilter.unfinishedRegistrations);
        });

    $scope.$on('refreshData', function (e, data) {
        $q.all([userRolesSvc.getAllAsync().$promise, referenceSourceSvc.getAllAsync().$promise])
            .then(function () {
                $scope.users = userSvc.getAllAsync(true, !$scope.customFilter.unfinishedRegistrations);
                if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
                    $scope.gridSettings.gridInstance.selectRows([], false);
                }

                setSelectedUser(null);                
            });
    });

    $scope.tabs = [
        {
            title: 'TXT_DETAIL',
            template: "users/users-detail-tabs/detail.html"
        },
        {
            title: 'TXT_LBL_STUDENTS',
            template: "users/users-detail-tabs/students.html"
        }
    ];
    
    if (hasSecondContact) {
        $scope.tabs.push({
            title: 'TXT_LBL_SECONDARY_CONTACT',
            template: "users/users-detail-tabs/second-contact.html"
        });        
    }
    
    $scope.tabs.activeTab = 0;

    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        $scope.$broadcast('activeTabChanged', { activeTab: newValue });
    });

    function setSelectedUser(data) {
        $scope.selectedUser = data;
        $scope.$broadcast('userSelectionChanged', $scope.selectedUser);
    }

    $scope.selectedUser = {};

    $scope.onRowSelected = function (data) {
        setSelectedUser(data);
    }

    $scope.onRowAdd = function () {
        var userDetail = userSvc.createNew();

        detailDialogPromise.$promise.then(function () {            
            detailDialogPromise.$scope.userDetail = angular.copy(userDetail);
            detailDialogPromise.$scope.userSaved = function (model) {
                if (!!$scope.gridSettings && !!$scope.gridSettings.gridInstance) {
                    $scope.gridSettings.gridInstance.refresh(true);
                    $scope.gridSettings.gridInstance.selectRows([model.id], false);
                    $scope.gridSettings.gridInstance.navigateToRow(model.id);
                }
            }
            detailDialogPromise.show();
        });
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.userDetail = angular.copy(data);
            detailDialogPromise.$scope.userSaved = function (model) {

            },
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        userSvc.remove(data);
    }


    var detailDialogPromise = $modal({
        templateUrl: 'users/users-detail.html',
        show: false,
        scope: $scope
    });

}]);


